import { Search, X } from "lucide-react";
import UIStore from "../../store/uiStore";

const SidebarSearch = () => {
  const query = UIStore((state) => state.sidebarQuery);
  const setQuery = UIStore((state) => state.setSidebarQuery);

  return (
    <div className="px-3 pt-2 flex-shrink-0">
      <div className="flex items-center gap-2 rounded-lg bg-fill-white border border-edge-hex-e2e8f0 dark:bg-fill-navigation-active dark:border-transparent px-2.5 py-1.5 shadow-sm dark:shadow-none">
        <Search className="w-3.5 h-3.5 text-ink-gray-400 dark:text-ink-gray-400 flex-shrink-0" />
        <label htmlFor="sidebar-search" className="sr-only">Search sidebar</label>
        <input
          id="sidebar-search"
          type="text"
          name="sidebar-search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search"
          className="flex-1 min-w-0 bg-transparent text-[13px] text-ink-ink-deep dark:text-ink-white placeholder:text-ink-gray-400 dark:placeholder:text-ink-gray-400 focus:outline-none"
        />
        {query ? (
          <button
            type="button"
            onClick={() => setQuery("")}
            className="flex-shrink-0 text-ink-gray-400 hover:text-ink-gray-600 dark:hover:text-ink-gray-200"
            aria-label="Clear search"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default SidebarSearch;
